/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ApiError,
  DiscordAuthResponse,
  DiscordInfoResponse,
  DiscordMemberJoinedBody,
  DiscordPresenceBody,
  DiscordPresenceSessionBody,
  DiscordRelayMessageBody,
  DiscordRelayMessageDeleteBody,
  DiscordRelayMessageHistoryBody,
  DiscordRelayMessageUpdateBody,
  DiscordRelayResponse,
  GetConnectedAccountResponse,
  GetDevourStatsResponse,
  RewardDailyXpBody,
} from '../models/index';
import {
    ApiErrorFromJSON,
    ApiErrorToJSON,
    DiscordAuthResponseFromJSON,
    DiscordAuthResponseToJSON,
    DiscordInfoResponseFromJSON,
    DiscordInfoResponseToJSON,
    DiscordMemberJoinedBodyFromJSON,
    DiscordMemberJoinedBodyToJSON,
    DiscordPresenceBodyFromJSON,
    DiscordPresenceBodyToJSON,
    DiscordPresenceSessionBodyFromJSON,
    DiscordPresenceSessionBodyToJSON,
    DiscordRelayMessageBodyFromJSON,
    DiscordRelayMessageBodyToJSON,
    DiscordRelayMessageDeleteBodyFromJSON,
    DiscordRelayMessageDeleteBodyToJSON,
    DiscordRelayMessageHistoryBodyFromJSON,
    DiscordRelayMessageHistoryBodyToJSON,
    DiscordRelayMessageUpdateBodyFromJSON,
    DiscordRelayMessageUpdateBodyToJSON,
    DiscordRelayResponseFromJSON,
    DiscordRelayResponseToJSON,
    GetConnectedAccountResponseFromJSON,
    GetConnectedAccountResponseToJSON,
    GetDevourStatsResponseFromJSON,
    GetDevourStatsResponseToJSON,
    RewardDailyXpBodyFromJSON,
    RewardDailyXpBodyToJSON,
} from '../models/index';

export interface CreateDiscordIntegrationRewardDailyXpRequest {
    rewardDailyXpBody: RewardDailyXpBody;
}

export interface CreateDiscordMemberJoinedRequest {
    discordMemberJoinedBody: DiscordMemberJoinedBody;
}

export interface CreateDiscordPresenceRequest {
    discordPresenceBody: DiscordPresenceBody;
}

export interface CreateDiscordPresenceSessionRequest {
    discordPresenceSessionBody: DiscordPresenceSessionBody;
}

export interface CreateDiscordRelayMessageRequest {
    discordRelayMessageBody: DiscordRelayMessageBody;
}

export interface CreateDiscordRelayMessageDeleteRequest {
    discordRelayMessageDeleteBody: DiscordRelayMessageDeleteBody;
}

export interface CreateDiscordRelayMessageHistoryRequest {
    discordRelayMessageHistoryBody: DiscordRelayMessageHistoryBody;
}

export interface CreateDiscordRelayMessageUpdateRequest {
    discordRelayMessageUpdateBody: DiscordRelayMessageUpdateBody;
}

export interface GetDiscordIntegrationGetConnectedAccountRequest {
    discordMemberId: string;
}

export interface GetDiscordIntegrationGetDevourStatsRequest {
    discordMemberId: string;
}

export interface GetLinkDiscordRequest {
    returnUrl?: string;
    origin?: GetLinkDiscordOriginEnum;
}

export interface GetLinkDiscordCallbackRequest {
    code: string;
    state: string;
}

/**
 * DiscordApi - interface
 * 
 * @export
 * @interface DiscordApiInterface
 */
export interface DiscordApiInterface {
    /**
     * Disconnects the discord account associated with the user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DiscordApiInterface
     */
    createDiscordAccountDisconnectRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<boolean>>;

    /**
     * Disconnects the discord account associated with the user
     */
    createDiscordAccountDisconnect(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<boolean>;

    /**
     * 
     * @summary Rewards daily XP to the specified Discord member
     * @param {RewardDailyXpBody} rewardDailyXpBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DiscordApiInterface
     */
    createDiscordIntegrationRewardDailyXpRaw(requestParameters: CreateDiscordIntegrationRewardDailyXpRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>>;

    /**
     * Rewards daily XP to the specified Discord member
     */
    createDiscordIntegrationRewardDailyXp(requestParameters: CreateDiscordIntegrationRewardDailyXpRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number>;

    /**
     * Called fire-and-forget by the Discord bot on guildMemberAdd for the community guild. Looks up the linked user by discord.id and emits the reusable discordServerJoined pipeline event, which credits the onboarding Join milestone in real time (QUEST_PROGRESSED socket → instant UI). No-ops for an unlinked joiner — the login/page reconcile membership check credits them later once their account is linked. 
     * @summary Credit the onboarding \"Join Discord\" step when a user joins the community server
     * @param {DiscordMemberJoinedBody} discordMemberJoinedBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DiscordApiInterface
     */
    createDiscordMemberJoinedRaw(requestParameters: CreateDiscordMemberJoinedRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Called fire-and-forget by the Discord bot on guildMemberAdd for the community guild. Looks up the linked user by discord.id and emits the reusable discordServerJoined pipeline event, which credits the onboarding Join milestone in real time (QUEST_PROGRESSED socket → instant UI). No-ops for an unlinked joiner — the login/page reconcile membership check credits them later once their account is linked. 
     * Credit the onboarding \"Join Discord\" step when a user joins the community server
     */
    createDiscordMemberJoined(requestParameters: CreateDiscordMemberJoinedRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Called by the Discord bot when it observes a PRESENCE_UPDATE carrying a console platform, for EVERY member it sees — presence is a guild-level signal, independent of DevourPlay linkage. Upserts one ConsolePresenceSession per (discordId × game × console platform), bumping the sighting count and lastSeenAt, and attaches userId when the Discord id resolves to a linked DevourPlay user. Docs with no userId are unlinked console players — the acquisition-funnel audience. No-ops only when there is no console activity in the payload. Console play is the only signal we have for PS/Xbox — no DevourPlay client runs there. 
     * @summary Persist a console (PlayStation / Xbox) game-presence sighting from the Discord bot
     * @param {DiscordPresenceBody} discordPresenceBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DiscordApiInterface
     */
    createDiscordPresenceRaw(requestParameters: CreateDiscordPresenceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Called by the Discord bot when it observes a PRESENCE_UPDATE carrying a console platform, for EVERY member it sees — presence is a guild-level signal, independent of DevourPlay linkage. Upserts one ConsolePresenceSession per (discordId × game × console platform), bumping the sighting count and lastSeenAt, and attaches userId when the Discord id resolves to a linked DevourPlay user. Docs with no userId are unlinked console players — the acquisition-funnel audience. No-ops only when there is no console activity in the payload. Console play is the only signal we have for PS/Xbox — no DevourPlay client runs there. 
     * Persist a console (PlayStation / Xbox) game-presence sighting from the Discord bot
     */
    createDiscordPresence(requestParameters: CreateDiscordPresenceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Called by the Discord bot as it observes a member\'s console presence. `start` and `heartbeat` open/extend a timed session held in backend Redis (durable across bot restarts — never bot memory); `stop` closes it, deriving minutes played and crediting it as an `owtimelogs` entry tagged source=console plus a reusable `console.play` pipeline event. Sessions with no heartbeat are also closed by a staleness sweep, so a missed stop (ungraceful power-off) still credits. No-ops for an unlinked member or a non-console platform. Console play is the only signal we have for PS/Xbox. 
     * @summary Track a console (PlayStation / Xbox) play session from Discord presence
     * @param {DiscordPresenceSessionBody} discordPresenceSessionBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DiscordApiInterface
     */
    createDiscordPresenceSessionRaw(requestParameters: CreateDiscordPresenceSessionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Called by the Discord bot as it observes a member\'s console presence. `start` and `heartbeat` open/extend a timed session held in backend Redis (durable across bot restarts — never bot memory); `stop` closes it, deriving minutes played and crediting it as an `owtimelogs` entry tagged source=console plus a reusable `console.play` pipeline event. Sessions with no heartbeat are also closed by a staleness sweep, so a missed stop (ungraceful power-off) still credits. No-ops for an unlinked member or a non-console platform. Console play is the only signal we have for PS/Xbox. 
     * Track a console (PlayStation / Xbox) play session from Discord presence
     */
    createDiscordPresenceSession(requestParameters: CreateDiscordPresenceSessionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Used by Discord bot to broadcast messages to web clients subscribed to specific channels
     * @summary Relay a Discord message to connected web clients
     * @param {DiscordRelayMessageBody} discordRelayMessageBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DiscordApiInterface
     */
    createDiscordRelayMessageRaw(requestParameters: CreateDiscordRelayMessageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DiscordRelayResponse>>;

    /**
     * Used by Discord bot to broadcast messages to web clients subscribed to specific channels
     * Relay a Discord message to connected web clients
     */
    createDiscordRelayMessage(requestParameters: CreateDiscordRelayMessageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DiscordRelayResponse>;

    /**
     * Used by Discord bot to broadcast message deletions to web clients
     * @summary Relay a Discord message deletion to connected web clients
     * @param {DiscordRelayMessageDeleteBody} discordRelayMessageDeleteBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DiscordApiInterface
     */
    createDiscordRelayMessageDeleteRaw(requestParameters: CreateDiscordRelayMessageDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DiscordRelayResponse>>;

    /**
     * Used by Discord bot to broadcast message deletions to web clients
     * Relay a Discord message deletion to connected web clients
     */
    createDiscordRelayMessageDelete(requestParameters: CreateDiscordRelayMessageDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DiscordRelayResponse>;

    /**
     * Used by Discord bot to send initial message history when a client subscribes to a channel
     * @summary Send message history to a specific client
     * @param {DiscordRelayMessageHistoryBody} discordRelayMessageHistoryBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DiscordApiInterface
     */
    createDiscordRelayMessageHistoryRaw(requestParameters: CreateDiscordRelayMessageHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DiscordRelayResponse>>;

    /**
     * Used by Discord bot to send initial message history when a client subscribes to a channel
     * Send message history to a specific client
     */
    createDiscordRelayMessageHistory(requestParameters: CreateDiscordRelayMessageHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DiscordRelayResponse>;

    /**
     * Used by Discord bot to broadcast message edits to web clients
     * @summary Relay a Discord message edit/update to connected web clients
     * @param {DiscordRelayMessageUpdateBody} discordRelayMessageUpdateBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DiscordApiInterface
     */
    createDiscordRelayMessageUpdateRaw(requestParameters: CreateDiscordRelayMessageUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DiscordRelayResponse>>;

    /**
     * Used by Discord bot to broadcast message edits to web clients
     * Relay a Discord message edit/update to connected web clients
     */
    createDiscordRelayMessageUpdate(requestParameters: CreateDiscordRelayMessageUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DiscordRelayResponse>;

    /**
     * Fetches the Discord account linked with the user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DiscordApiInterface
     */
    getDiscordAccountRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DiscordInfoResponse>>;

    /**
     * Fetches the Discord account linked with the user
     */
    getDiscordAccount(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DiscordInfoResponse>;

    /**
     * 
     * @summary Retrieves the user ID associated with a given Discord member ID
     * @param {string} discordMemberId The Discord member ID to check for connection
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DiscordApiInterface
     */
    getDiscordIntegrationGetConnectedAccountRaw(requestParameters: GetDiscordIntegrationGetConnectedAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetConnectedAccountResponse>>;

    /**
     * Retrieves the user ID associated with a given Discord member ID
     */
    getDiscordIntegrationGetConnectedAccount(requestParameters: GetDiscordIntegrationGetConnectedAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetConnectedAccountResponse>;

    /**
     * 
     * @summary Retrieve GoVIP level and experience points for a Discord member
     * @param {string} discordMemberId The Discord member ID for retrieving Devour stats
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DiscordApiInterface
     */
    getDiscordIntegrationGetDevourStatsRaw(requestParameters: GetDiscordIntegrationGetDevourStatsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetDevourStatsResponse>>;

    /**
     * Retrieve GoVIP level and experience points for a Discord member
     */
    getDiscordIntegrationGetDevourStats(requestParameters: GetDiscordIntegrationGetDevourStatsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetDevourStatsResponse>;

    /**
     * Fetches the Discord OAuth2 URL for account linking.
     * @param {string} [returnUrl] Path to return to after OAuth completes (e.g. /discord-callback or /account; for the portal, a relative portal route like /dashboard or /drops/{id})
     * @param {'portal'} [origin] Set to \&quot;portal\&quot; when linking from the Drop-In creator portal. The callback then returns to the portal (PUBLIC_PORTAL_URL + returnUrl) instead of the web app.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DiscordApiInterface
     */
    getLinkDiscordRaw(requestParameters: GetLinkDiscordRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DiscordAuthResponse>>;

    /**
     * Fetches the Discord OAuth2 URL for account linking.
     */
    getLinkDiscord(requestParameters: GetLinkDiscordRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DiscordAuthResponse>;

    /**
     * OAuth2 callback endpoint. Discord redirects here after authorization. Validates the HMAC-signed state, exchanges the code for an access token, links the Discord account, and redirects to the frontend.
     * @param {string} code Authorization code from Discord
     * @param {string} state Base64-encoded HMAC-signed state parameter
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DiscordApiInterface
     */
    getLinkDiscordCallbackRaw(requestParameters: GetLinkDiscordCallbackRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * OAuth2 callback endpoint. Discord redirects here after authorization. Validates the HMAC-signed state, exchanges the code for an access token, links the Discord account, and redirects to the frontend.
     */
    getLinkDiscordCallback(requestParameters: GetLinkDiscordCallbackRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

}

/**
 * 
 */
export class DiscordApi extends runtime.BaseAPI implements DiscordApiInterface {

    /**
     * Disconnects the discord account associated with the user
     */
    async createDiscordAccountDisconnectRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<boolean>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/discord/account/disconnect`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<boolean>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Disconnects the discord account associated with the user
     */
    async createDiscordAccountDisconnect(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<boolean> {
        const response = await this.createDiscordAccountDisconnectRaw(initOverrides);
        return await response.value();
    }

    /**
     * Rewards daily XP to the specified Discord member
     */
    async createDiscordIntegrationRewardDailyXpRaw(requestParameters: CreateDiscordIntegrationRewardDailyXpRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['rewardDailyXpBody'] == null) {
            throw new runtime.RequiredError(
                'rewardDailyXpBody',
                'Required parameter "rewardDailyXpBody" was null or undefined when calling createDiscordIntegrationRewardDailyXp().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/discord/integration/reward_daily_xp`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RewardDailyXpBodyToJSON(requestParameters['rewardDailyXpBody']),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Rewards daily XP to the specified Discord member
     */
    async createDiscordIntegrationRewardDailyXp(requestParameters: CreateDiscordIntegrationRewardDailyXpRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.createDiscordIntegrationRewardDailyXpRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Called fire-and-forget by the Discord bot on guildMemberAdd for the community guild. Looks up the linked user by discord.id and emits the reusable discordServerJoined pipeline event, which credits the onboarding Join milestone in real time (QUEST_PROGRESSED socket → instant UI). No-ops for an unlinked joiner — the login/page reconcile membership check credits them later once their account is linked. 
     * Credit the onboarding \"Join Discord\" step when a user joins the community server
     */
    async createDiscordMemberJoinedRaw(requestParameters: CreateDiscordMemberJoinedRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['discordMemberJoinedBody'] == null) {
            throw new runtime.RequiredError(
                'discordMemberJoinedBody',
                'Required parameter "discordMemberJoinedBody" was null or undefined when calling createDiscordMemberJoined().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/discord/member-joined`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DiscordMemberJoinedBodyToJSON(requestParameters['discordMemberJoinedBody']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Called fire-and-forget by the Discord bot on guildMemberAdd for the community guild. Looks up the linked user by discord.id and emits the reusable discordServerJoined pipeline event, which credits the onboarding Join milestone in real time (QUEST_PROGRESSED socket → instant UI). No-ops for an unlinked joiner — the login/page reconcile membership check credits them later once their account is linked. 
     * Credit the onboarding \"Join Discord\" step when a user joins the community server
     */
    async createDiscordMemberJoined(requestParameters: CreateDiscordMemberJoinedRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.createDiscordMemberJoinedRaw(requestParameters, initOverrides);
    }

    /**
     * Called by the Discord bot when it observes a PRESENCE_UPDATE carrying a console platform, for EVERY member it sees — presence is a guild-level signal, independent of DevourPlay linkage. Upserts one ConsolePresenceSession per (discordId × game × console platform), bumping the sighting count and lastSeenAt, and attaches userId when the Discord id resolves to a linked DevourPlay user. Docs with no userId are unlinked console players — the acquisition-funnel audience. No-ops only when there is no console activity in the payload. Console play is the only signal we have for PS/Xbox — no DevourPlay client runs there. 
     * Persist a console (PlayStation / Xbox) game-presence sighting from the Discord bot
     */
    async createDiscordPresenceRaw(requestParameters: CreateDiscordPresenceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['discordPresenceBody'] == null) {
            throw new runtime.RequiredError(
                'discordPresenceBody',
                'Required parameter "discordPresenceBody" was null or undefined when calling createDiscordPresence().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/discord/presence`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DiscordPresenceBodyToJSON(requestParameters['discordPresenceBody']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Called by the Discord bot when it observes a PRESENCE_UPDATE carrying a console platform, for EVERY member it sees — presence is a guild-level signal, independent of DevourPlay linkage. Upserts one ConsolePresenceSession per (discordId × game × console platform), bumping the sighting count and lastSeenAt, and attaches userId when the Discord id resolves to a linked DevourPlay user. Docs with no userId are unlinked console players — the acquisition-funnel audience. No-ops only when there is no console activity in the payload. Console play is the only signal we have for PS/Xbox — no DevourPlay client runs there. 
     * Persist a console (PlayStation / Xbox) game-presence sighting from the Discord bot
     */
    async createDiscordPresence(requestParameters: CreateDiscordPresenceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.createDiscordPresenceRaw(requestParameters, initOverrides);
    }

    /**
     * Called by the Discord bot as it observes a member\'s console presence. `start` and `heartbeat` open/extend a timed session held in backend Redis (durable across bot restarts — never bot memory); `stop` closes it, deriving minutes played and crediting it as an `owtimelogs` entry tagged source=console plus a reusable `console.play` pipeline event. Sessions with no heartbeat are also closed by a staleness sweep, so a missed stop (ungraceful power-off) still credits. No-ops for an unlinked member or a non-console platform. Console play is the only signal we have for PS/Xbox. 
     * Track a console (PlayStation / Xbox) play session from Discord presence
     */
    async createDiscordPresenceSessionRaw(requestParameters: CreateDiscordPresenceSessionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['discordPresenceSessionBody'] == null) {
            throw new runtime.RequiredError(
                'discordPresenceSessionBody',
                'Required parameter "discordPresenceSessionBody" was null or undefined when calling createDiscordPresenceSession().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/discord/presence-session`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DiscordPresenceSessionBodyToJSON(requestParameters['discordPresenceSessionBody']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Called by the Discord bot as it observes a member\'s console presence. `start` and `heartbeat` open/extend a timed session held in backend Redis (durable across bot restarts — never bot memory); `stop` closes it, deriving minutes played and crediting it as an `owtimelogs` entry tagged source=console plus a reusable `console.play` pipeline event. Sessions with no heartbeat are also closed by a staleness sweep, so a missed stop (ungraceful power-off) still credits. No-ops for an unlinked member or a non-console platform. Console play is the only signal we have for PS/Xbox. 
     * Track a console (PlayStation / Xbox) play session from Discord presence
     */
    async createDiscordPresenceSession(requestParameters: CreateDiscordPresenceSessionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.createDiscordPresenceSessionRaw(requestParameters, initOverrides);
    }

    /**
     * Used by Discord bot to broadcast messages to web clients subscribed to specific channels
     * Relay a Discord message to connected web clients
     */
    async createDiscordRelayMessageRaw(requestParameters: CreateDiscordRelayMessageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DiscordRelayResponse>> {
        if (requestParameters['discordRelayMessageBody'] == null) {
            throw new runtime.RequiredError(
                'discordRelayMessageBody',
                'Required parameter "discordRelayMessageBody" was null or undefined when calling createDiscordRelayMessage().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/discord/relay-message`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DiscordRelayMessageBodyToJSON(requestParameters['discordRelayMessageBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DiscordRelayResponseFromJSON(jsonValue));
    }

    /**
     * Used by Discord bot to broadcast messages to web clients subscribed to specific channels
     * Relay a Discord message to connected web clients
     */
    async createDiscordRelayMessage(requestParameters: CreateDiscordRelayMessageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DiscordRelayResponse> {
        const response = await this.createDiscordRelayMessageRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Used by Discord bot to broadcast message deletions to web clients
     * Relay a Discord message deletion to connected web clients
     */
    async createDiscordRelayMessageDeleteRaw(requestParameters: CreateDiscordRelayMessageDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DiscordRelayResponse>> {
        if (requestParameters['discordRelayMessageDeleteBody'] == null) {
            throw new runtime.RequiredError(
                'discordRelayMessageDeleteBody',
                'Required parameter "discordRelayMessageDeleteBody" was null or undefined when calling createDiscordRelayMessageDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/discord/relay-message-delete`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DiscordRelayMessageDeleteBodyToJSON(requestParameters['discordRelayMessageDeleteBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DiscordRelayResponseFromJSON(jsonValue));
    }

    /**
     * Used by Discord bot to broadcast message deletions to web clients
     * Relay a Discord message deletion to connected web clients
     */
    async createDiscordRelayMessageDelete(requestParameters: CreateDiscordRelayMessageDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DiscordRelayResponse> {
        const response = await this.createDiscordRelayMessageDeleteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Used by Discord bot to send initial message history when a client subscribes to a channel
     * Send message history to a specific client
     */
    async createDiscordRelayMessageHistoryRaw(requestParameters: CreateDiscordRelayMessageHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DiscordRelayResponse>> {
        if (requestParameters['discordRelayMessageHistoryBody'] == null) {
            throw new runtime.RequiredError(
                'discordRelayMessageHistoryBody',
                'Required parameter "discordRelayMessageHistoryBody" was null or undefined when calling createDiscordRelayMessageHistory().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/discord/relay-message-history`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DiscordRelayMessageHistoryBodyToJSON(requestParameters['discordRelayMessageHistoryBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DiscordRelayResponseFromJSON(jsonValue));
    }

    /**
     * Used by Discord bot to send initial message history when a client subscribes to a channel
     * Send message history to a specific client
     */
    async createDiscordRelayMessageHistory(requestParameters: CreateDiscordRelayMessageHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DiscordRelayResponse> {
        const response = await this.createDiscordRelayMessageHistoryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Used by Discord bot to broadcast message edits to web clients
     * Relay a Discord message edit/update to connected web clients
     */
    async createDiscordRelayMessageUpdateRaw(requestParameters: CreateDiscordRelayMessageUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DiscordRelayResponse>> {
        if (requestParameters['discordRelayMessageUpdateBody'] == null) {
            throw new runtime.RequiredError(
                'discordRelayMessageUpdateBody',
                'Required parameter "discordRelayMessageUpdateBody" was null or undefined when calling createDiscordRelayMessageUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/discord/relay-message-update`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DiscordRelayMessageUpdateBodyToJSON(requestParameters['discordRelayMessageUpdateBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DiscordRelayResponseFromJSON(jsonValue));
    }

    /**
     * Used by Discord bot to broadcast message edits to web clients
     * Relay a Discord message edit/update to connected web clients
     */
    async createDiscordRelayMessageUpdate(requestParameters: CreateDiscordRelayMessageUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DiscordRelayResponse> {
        const response = await this.createDiscordRelayMessageUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Fetches the Discord account linked with the user
     */
    async getDiscordAccountRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DiscordInfoResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/discord/account`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DiscordInfoResponseFromJSON(jsonValue));
    }

    /**
     * Fetches the Discord account linked with the user
     */
    async getDiscordAccount(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DiscordInfoResponse> {
        const response = await this.getDiscordAccountRaw(initOverrides);
        return await response.value();
    }

    /**
     * Retrieves the user ID associated with a given Discord member ID
     */
    async getDiscordIntegrationGetConnectedAccountRaw(requestParameters: GetDiscordIntegrationGetConnectedAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetConnectedAccountResponse>> {
        if (requestParameters['discordMemberId'] == null) {
            throw new runtime.RequiredError(
                'discordMemberId',
                'Required parameter "discordMemberId" was null or undefined when calling getDiscordIntegrationGetConnectedAccount().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['discordMemberId'] != null) {
            queryParameters['discordMemberId'] = requestParameters['discordMemberId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/discord/integration/get_connected_account`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetConnectedAccountResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves the user ID associated with a given Discord member ID
     */
    async getDiscordIntegrationGetConnectedAccount(requestParameters: GetDiscordIntegrationGetConnectedAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetConnectedAccountResponse> {
        const response = await this.getDiscordIntegrationGetConnectedAccountRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve GoVIP level and experience points for a Discord member
     */
    async getDiscordIntegrationGetDevourStatsRaw(requestParameters: GetDiscordIntegrationGetDevourStatsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetDevourStatsResponse>> {
        if (requestParameters['discordMemberId'] == null) {
            throw new runtime.RequiredError(
                'discordMemberId',
                'Required parameter "discordMemberId" was null or undefined when calling getDiscordIntegrationGetDevourStats().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['discordMemberId'] != null) {
            queryParameters['discordMemberId'] = requestParameters['discordMemberId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/discord/integration/get_devour_stats`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetDevourStatsResponseFromJSON(jsonValue));
    }

    /**
     * Retrieve GoVIP level and experience points for a Discord member
     */
    async getDiscordIntegrationGetDevourStats(requestParameters: GetDiscordIntegrationGetDevourStatsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetDevourStatsResponse> {
        const response = await this.getDiscordIntegrationGetDevourStatsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Fetches the Discord OAuth2 URL for account linking.
     */
    async getLinkDiscordRaw(requestParameters: GetLinkDiscordRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DiscordAuthResponse>> {
        const queryParameters: any = {};

        if (requestParameters['returnUrl'] != null) {
            queryParameters['returnUrl'] = requestParameters['returnUrl'];
        }

        if (requestParameters['origin'] != null) {
            queryParameters['origin'] = requestParameters['origin'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/link-discord`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DiscordAuthResponseFromJSON(jsonValue));
    }

    /**
     * Fetches the Discord OAuth2 URL for account linking.
     */
    async getLinkDiscord(requestParameters: GetLinkDiscordRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DiscordAuthResponse> {
        const response = await this.getLinkDiscordRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * OAuth2 callback endpoint. Discord redirects here after authorization. Validates the HMAC-signed state, exchanges the code for an access token, links the Discord account, and redirects to the frontend.
     */
    async getLinkDiscordCallbackRaw(requestParameters: GetLinkDiscordCallbackRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['code'] == null) {
            throw new runtime.RequiredError(
                'code',
                'Required parameter "code" was null or undefined when calling getLinkDiscordCallback().'
            );
        }

        if (requestParameters['state'] == null) {
            throw new runtime.RequiredError(
                'state',
                'Required parameter "state" was null or undefined when calling getLinkDiscordCallback().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['code'] != null) {
            queryParameters['code'] = requestParameters['code'];
        }

        if (requestParameters['state'] != null) {
            queryParameters['state'] = requestParameters['state'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/link-discord/callback`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * OAuth2 callback endpoint. Discord redirects here after authorization. Validates the HMAC-signed state, exchanges the code for an access token, links the Discord account, and redirects to the frontend.
     */
    async getLinkDiscordCallback(requestParameters: GetLinkDiscordCallbackRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.getLinkDiscordCallbackRaw(requestParameters, initOverrides);
    }

}

/**
 * @export
 */
export const GetLinkDiscordOriginEnum = {
    Portal: 'portal'
} as const;
export type GetLinkDiscordOriginEnum = typeof GetLinkDiscordOriginEnum[keyof typeof GetLinkDiscordOriginEnum];
